/*
 * Neyli – Suivi de commande : SOURCE DE DONNÉES FICTIVES
 * -------------------------------------------------------
 * Ce fichier est volontairement séparé de la logique d'affichage
 * (neyli-suivi-commande.js). Pour brancher une vraie source plus tard
 * (app de suivi, App Proxy Shopify, API transporteur…), il suffit de
 * remplacer la fonction `lookup` ci-dessous par un appel réseau qui
 * renvoie le même format d'objet. Rien d'autre n'est à modifier.
 *
 * Format attendu renvoyé par lookup(numero) :
 *   Promise<null>                      -> commande introuvable
 *   Promise<{
 *     numero: '#1003',
 *     etape: 'recue' | 'preparation' | 'expediee' | 'livraison' | 'livree',
 *     date: '2026-10-12',              // date de commande (ISO)
 *     livraisonEstimee: '2026-10-17',  // optionnel
 *     transporteur: 'Colissimo',       // optionnel
 *     detail: 'Texte libre',           // optionnel
 *     dates: { recue: '…', preparation: '…', … } // optionnel, date de chaque étape
 *   }>
 */
(function () {
  const COMMANDES_FICTIVES = {
    1001: {
      numero: '#1001',
      etape: 'recue',
      date: '2026-10-17',
      livraisonEstimee: '2026-10-23',
      detail: 'Nous avons bien reçu votre commande. Elle sera préparée très prochainement.',
      dates: { recue: '2026-10-17' },
    },
    1002: {
      numero: '#1002',
      etape: 'preparation',
      date: '2026-10-15',
      livraisonEstimee: '2026-10-21',
      detail: 'Votre tapis d’éveil est en cours de préparation avec soin dans notre atelier.',
      dates: { recue: '2026-10-15', preparation: '2026-10-16' },
    },
    1003: {
      numero: '#1003',
      etape: 'expediee',
      date: '2026-10-13',
      livraisonEstimee: '2026-10-19',
      transporteur: 'Colissimo',
      detail: 'Votre colis a quitté notre entrepôt.',
      dates: { recue: '2026-10-13', preparation: '2026-10-14', expediee: '2026-10-15' },
    },
    1004: {
      numero: '#1004',
      etape: 'livraison',
      date: '2026-10-11',
      livraisonEstimee: '2026-10-18',
      transporteur: 'Colissimo',
      detail: 'Votre colis est en route vers votre adresse. Livraison prévue aujourd’hui.',
      dates: { recue: '2026-10-11', preparation: '2026-10-12', expediee: '2026-10-14', livraison: '2026-10-18' },
    },
    1005: {
      numero: '#1005',
      etape: 'livree',
      date: '2026-10-02',
      transporteur: 'Colissimo',
      detail: 'Votre commande a été livrée. Merci pour votre confiance !',
      dates: {
        recue: '2026-10-02',
        preparation: '2026-10-03',
        expediee: '2026-10-05',
        livraison: '2026-10-07',
        livree: '2026-10-07',
      },
    },
  };

  /** Simule un appel réseau (petit délai) puis renvoie la commande ou null. */
  function lookup(numero) {
    const cle = String(numero).replace(/[^0-9]/g, '');
    return new Promise((resolve) => {
      setTimeout(() => resolve(COMMANDES_FICTIVES[cle] || null), 450);
    });
  }

  window.NeyliSuiviData = { lookup, estFictif: true };
})();
